import React, { useState } from 'react'
import { Button, Table, Modal, ModalBody, ModalHeader, ModalFooter, UncontrolledAccordion, AccordionItem, AccordionBody, AccordionHeader, Input, Label, FormGroup } from 'reactstrap';
import ClaimDocumentUploadCommonModal from './ClaimDocumentUploadCommonModal';
import MultipleLORFilesUploadModal from './MultipleLORFilesUploadModal';
import MultipleLorAddCommonModal from './MultipleLorAddCommonModal';
import JirLorUploadCommonModal from './JirLorUploadCommonModal';
import { raiseClaimService } from '../../services';
import { toast } from 'react-toastify';
import DownloadAnyFile from '../common/DownloadAnyFile';
import Loading from '../common/Loading';
import { FaInfoCircle } from 'react-icons/fa';
import { jwtDecode } from 'jwt-decode';
import CommonDocumentCommentModal from './CommonDocumentCommentModal';
import CommonCommentModal from './CommonCommentModal';
import MultipleOtherDocModal from './MultipleOtherDocRequiredModal';
import MultipleAmountAddCommonModal from './MultipleAmountAddCommonModal';
import { aesUtil } from '../../utils/aesUtil';

const ClaimDocumentTabCmp = ({ tabLoading, activeTab, title, documentDetails, fetchClaimDocument, claimId, fetchClaimTemplateDetails, detailedClaim }) => {

    let data = localStorage.getItem('token');
    const decryptToken = typeof data === 'string' ? aesUtil.decrypt(data) : '';
    const decoded = typeof decryptToken === 'string' ? jwtDecode(decryptToken) : null;
    const userRole = decoded?.Role;
    const { claimDetails, lorCount, otherDocument, PrDcDocument } = documentDetails;
    const [showAddModal, setShowAddModal] = useState(false);
    const [showAddLorFilesModal, setShowAddLorFilesModal] = useState(false);
    const [showAddOtherModal, setShowAddOtherModal] = useState(false);
    const [addCommentModal, setAddCommentModal] = useState(false);
    const [showCommentModal, setShowCommentModal] = useState(false);
    const [commentedUserType, setCommentedUserType] = useState(null);
    const [lorDetails, setLorDetails] = useState({});
    const [commentsList, setCommentsList] = useState([]);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteFiles, setDeleteFiles] = useState([]);
    const [showAddLorModal, setShowAddLorModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showMultipleFileDeleteModal, setShowMultipleFileDeleteModal] = useState(false);
    const [showSettlementModal, setShowSettlementModal] = useState(false);
    const [settlementType, setSettlementType] = useState('');
    const [fileType, setFileType] = useState('');
    const [otherDocTaggedRole, setOtherDocTaggedRole] = useState('');
    const [requiredNameDeleteDetails, setRequiredNameDeleteDetails] = useState('');
    const [showDeleteReqNameModal, setShowDeleteReqNameModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClose = (type) => {
        if (type === "DELETE") {
            setShowDeleteModal(false)
            setShowMultipleFileDeleteModal(false)
        } else if (type === "ADD_COMMENT") {
            setLorDetails(null)
            setAddCommentModal(false)
        } else if (type === "SHOW_COMMENT") {
            setCommentsList([])
            setShowCommentModal(false)
        }
        else
            setShowAddModal(false)
        setShowAddLorFilesModal(false)
    }

    const handleShow = (type) => {
        if (type === "DELETE") {
            setShowDeleteModal(true)
        } else if (type === "ADD_COMMENT") {
            setAddCommentModal(true)
        } else if (type === "SHOW_COMMENT") {
            setShowCommentModal(true)
        }
        else
            setShowAddModal(true)
    };

    const handleAddMultipleLORFiles = (lorValues) => {
        setLorDetails(lorValues)
        setShowAddLorFilesModal(true)
    }

    const handleAddMultipleLOR = () => {
        setShowAddLorModal(true)
    }

    const generateFileType = () => {
        let type = ''
        switch (activeTab) {
            case "CLAIM_DOC_LIST_DURING_RAISE":
                type = 'raise_claim_document'
                break;
            case "JIR_DOCUMENTS":
                type = 'jir'
                break;
            case "LOR_DOCUMENTS":
                type = 'lor'
                break;
            case "FSR_DOCUMENTS":
                type = 'fsr'
                break;
            default:
                type = 'raise_claim_document'
                break;
        }
        return type
    };

    const generateFileName = () => {
        let type = ''
        switch (activeTab) {
            case "CLAIM_DOC_LIST_DURING_RAISE":
                type = 'Raised-Claim-Documents'
                break;
            case "JIR_DOCUMENTS":
                type = 'JIR-Documents'
                break;
            case "LOR_DOCUMENTS":
                type = 'LOR-Documents'
                break;
            case "FSR_DOCUMENTS":
                type = 'FSR-Documents'
                break;
            default:
                type = 'raise_claim_document'
                break;
        }
        return type
    };

    const downloadAll = async (fileType = null) => {
        const mainFileType = generateFileType();
        const payload_data = {
            claimId: claimId || 0,
            fileId: 0,
            lorRequiredId: activeTab === "LOR_DOCUMENTS" && documentDetails?.lorRequiredId ? documentDetails?.lorRequiredId : 0,
            fileType: mainFileType === 'fsr' ? fileType : mainFileType
        };
        const fileName = generateFileName();
        setIsLoading(true);
        await DownloadAnyFile({ url: 'RaiseClaim/download-files', payload: payload_data, filename: mainFileType === 'fsr' ? fileType === 'fsr' ? 'FSR' : fileType === 'other_document' ? 'Other Documents' : 'Final Police Report' : fileName, ext: ".zip" });
        setIsLoading(false);
    };

    const downloadDoc = async (doc, fileType = null) => {
        const mainFileType = generateFileType();
        let payload_data = {}
        if (activeTab === 'LOR_DOCUMENTS') {
            payload_data = {
                claimId: claimId || 0,
                fileId: doc?.lorRequiredName ? 0 : doc?.files?.[0]?.fileId,
                lorRequiredId: doc?.lorRequiredId || 0,
                fileType: mainFileType
            };
        }
        else if (activeTab === 'FSR_DOCUMENTS' && fileType !== 'fsr') {
            payload_data = {
                claimId: claimId || 0,
                fileId: doc?.lorRequiredName && doc?.lorRequiredName !== 'destruction_certificate' && doc?.lorRequiredName !== 'final_police_report' ? 0 : doc?.files?.[0]?.fileId,
                lorRequiredId: doc?.lorRequiredId || 0,
                fileType: fileType
            };
        } else {
            payload_data = {
                claimId: claimId || 0,
                fileId: doc?.fileId || 0,
                lorRequiredId: doc?.lorRequiredId || 0,
                fileType: mainFileType
            }
        }
        setIsLoading(true);
        await DownloadAnyFile({ url: 'RaiseClaim/download-files', payload: payload_data, filename: doc?.fileName || ((activeTab === 'LOR_DOCUMENTS' || activeTab === "FSR_DOCUMENTS" && fileType !== 'fsr') && (doc?.lorRequiredName || doc?.files?.[0]?.fileName || "LOR-Document")) || "Raised-Claim-Document", ext: ".zip" });
        setIsLoading(false);
    };

    const AddDoc = async (values) => {
        const formData = new FormData();
        formData.append('claimId', claimId || 0);
        values?.files?.length > 0 && values.files.forEach((fileObj, index) => {
            formData.append(`files[${index}].fileContent`, fileObj.file || '');
            formData.append(`files[${index}].fileDescription`, fileObj.description || '');
            formData.append(`files[${index}].fileType`, activeTab === 'FSR_DOCUMENTS' ? fileType : generateFileType()) // Append the corresponding description         
        });
        setIsLoading(true);
        const response = await raiseClaimService.addFiles(formData);
        setIsLoading(false);
        if (response?.isSuccess) {
            await fetchClaimDocument()
            await fetchClaimTemplateDetails(claimId)
            toast.success(response?.message);
            handleClose();
        } else {
            toast.error(response?.data?.message);
        }
    };

    const AddLORAndJIRFiles = async (values) => {
        const formData = new FormData();
        formData.append('claimId', claimId || 0);
        values.files?.length > 0 && values.files.forEach((fileObj, index) => {
            formData.append(`files[${index}].fileContent`, fileObj.file || ''); // Append the file
            formData.append(`files[${index}].fileDescription`, fileObj.description || '');  // Append the corresponding description
            formData.append(`files[${index}].fileType`, generateFileType()) // Append the corresponding description         
        });
        values?.requiredDocList?.length > 0 && values.requiredDocList.forEach((doc, index) => {
            formData.append(`lorRequires[${index}].lorRequiredName`, doc.requireDoc || ''); // Append the file
        });
        setIsLoading(true);
        const response = await raiseClaimService.addJirAndLor(formData);
        setIsLoading(false);
        if (response?.isSuccess) {
            await fetchClaimDocument()
            await fetchClaimTemplateDetails(claimId)
            toast.success(response?.message);
            handleClose();
        } else {
            toast.error(response?.data?.message);
        }
    }

    const AddLOR = async (values) => {
        const formData = new FormData();
        formData.append('claimId', claimId || 0);
        values?.requiredDocList?.length > 0 && values.requiredDocList.forEach((doc, index) => {
            formData.append(`lorRequires[${index}].lorRequiredName`, doc.requireDoc || ''); // Append the file
        });
        setIsLoading(true);
        const response = await raiseClaimService.addJirAndLor(formData);
        setIsLoading(false);
        if (response?.isSuccess) {
            await fetchClaimDocument()
            toast.success(response?.message);
            setShowAddLorModal(false);
        } else {
            toast.error(response?.data?.message);
        }
    }

    const AddOtherDocReq = async (values) => {
        const formData = new FormData();
        formData.append('claimId', claimId || 0);
        values?.requiredDocList?.length > 0 && values.requiredDocList.forEach((doc, index) => {
            formData.append(`lorRequires[${index}].lorRequiredName`, doc.requireDoc || '');
            formData.append(`lorRequiredType`, 'other_document_required');
            formData.append(`lorRequires[${index}].taggedRole`, doc.taggedRole || ''); // Append the file
        });
        setIsLoading(true);
        const response = await raiseClaimService.addJirAndLor(formData);
        setIsLoading(false);
        if (response?.isSuccess) {
            await fetchClaimDocument()
            await fetchClaimTemplateDetails(claimId)
            toast.success(response?.message);
            setShowAddLorModal(false);
        } else {
            toast.error(response?.data?.message);
        }
    }

    const AddLORFiles = async (values) => {
        const mainFileType = generateFileType();
        const formData = new FormData();
        formData.append('claimId', claimId || 0);
        values?.files?.length > 0 && values.files.forEach((fileObj, index) => {
            formData.append(`files[${index}].fileContent`, fileObj.file || '');
            formData.append(`files[${index}].fileType`, mainFileType === 'fsr' ? fileType : mainFileType)
            formData.append(`files[${index}].fileDescription`, fileType === 'final_police_report' || fileType === 'destruction_certificate' ? (values?.lorDescription || '') : '')
            // Append the corresponding description         
            // Append the file
        });
        formData.append(`lorRequiredId`, values?.lorRequiredId || '');
        if (mainFileType === 'lor' || fileType === 'other_document') {
            formData.append(`lorDescription`, values?.lorDescription || '');
        }
        setIsLoading(true);
        const response = await raiseClaimService.addFiles(formData);
        setIsLoading(false);
        if (response?.isSuccess) {
            await fetchClaimDocument()
            await fetchClaimTemplateDetails(claimId)
            toast.success(response?.message);
            handleClose();
        } else {
            toast.error(response?.data?.message);
        }
    }

    const handleDelete = async () => {
        const type = generateFileType();
        const payload = {
            claimId: claimId || 0,
            fileId: deleteId || 0,
            fileType: type === 'fsr' ? fileType : type
        };
        setIsLoading(true);
        const response = await raiseClaimService.deleteDoc(payload);
        setIsLoading(false);
        if (response?.isSuccess) {
            await fetchClaimDocument()
            toast.success(response?.message);
            handleClose('DELETE');
        } else {
            toast.error(response?.data?.message);
        }
    }

    const modalTitleHandler = (type) => {
        switch (type) {
            case 'JIR_DOCUMENTS':
                return "JIR Document"
            case 'LOR_DOCUMENTS':
                return "LOR Document"
            case 'FSR_DOCUMENTS':
                return "FSR Document"

            default:
                return "Document"
        }
    }

    const addComment = async (values) => {
        let payload = {};
        if (activeTab === 'LOR_DOCUMENTS') {
            payload = {
                claimId: claimId || 0,
                recordId: lorDetails?.lorRequiredId || 0,
                commentId: 0,
                commentDescription: values?.comment || 0,
                taggedRole: userRole === 'Divisional SPOC' ? 'Surveyor' : userRole === 'Surveyor' ? 'Divisional SPOC' : '',
                commentType: userRole === 'Divisional SPOC' ? 'lor_required' : userRole === 'Surveyor' ? 'lor' : ''
            };
        }
        else {
            payload = {
                claimId: claimId || 0,
                recordId: lorDetails?.lorRequiredId || 0,
                commentId: 0,
                commentDescription: values?.comment || 0,
                taggedRole: userRole === 'Insurer' ? otherDocTaggedRole : userRole === 'Surveyor' || 'Divisional SPOC' ? 'Insurer' : '',
                commentType: userRole === 'Divisional SPOC' || userRole === 'Surveyor' ? 'other_document_required' : userRole === 'Insurer' ? 'other_document' : ''
            };
        }
        setIsLoading(true);
        const response = await raiseClaimService.addComment(payload);
        if (response?.isSuccess) {
            await fetchClaimDocument()
            await fetchClaimTemplateDetails(claimId)
            toast.success(response?.message);
            handleClose('ADD_COMMENT');
        } else {
            toast.error(response?.data?.message);
        }
        setIsLoading(false);
    }

    const showCommentHandler = (comments, roleArray, userType) => {
        setCommentsList(comments.filter(item => roleArray.includes(item.userRole)));
        setCommentedUserType(userType)
        handleShow('SHOW_COMMENT')
    }

    const handleDeleteRequiredName = async (type) => {
        const payload = {
            lorRequiredId: requiredNameDeleteDetails?.id,
            lorRequiredType: requiredNameDeleteDetails?.type,
            claimId: claimId
        }
        setIsLoading(true);
        const response = await raiseClaimService.deleteRequiredName(payload);
        if (response?.isSuccess) {
            await fetchClaimDocument()
            await fetchClaimTemplateDetails(claimId)
            toast.success(response?.message);
        } else {
            toast.error(response?.data?.message);
        }
        setShowDeleteReqNameModal(false);
        setIsLoading(false);
    }

    const getAssesmentLabel = () => {
        const estimatedLoss = detailedClaim?.estimatedLoss;
        if (estimatedLoss && estimatedLoss > 25000) {
            return 'Surveyor Assessment Amount'
        } else {
            return 'Assessment Amount'
        }
    }

    const canAddLor = () => {
        const isSTPPolicy = detailedClaim?.policyName?.toLowerCase().includes('stp');
        const isSTPZeroOrOne = detailedClaim?.policyName?.toLowerCase() === 'stp0' || detailedClaim?.policyName?.toLowerCase() === 'stp 0' || detailedClaim?.policyName?.toLowerCase() === 'stp 1' || detailedClaim?.policyName?.toLowerCase() === 'stp1';
        const isEstimatedLossNotMore25000 = !(detailedClaim?.estimatedLoss > 25000);
        const isClaimMarine = detailedClaim?.storageTransitType?.toLowerCase() === 'transit';
        const isMisc = detailedClaim?.policyType?.toLowerCase().includes('misc') || detailedClaim?.policyType?.toLowerCase().includes('miscellaneous');
        const isMiscPolicy = isMisc && detailedClaim?.policyName?.toLowerCase().includes('PEEI'.toLocaleLowerCase()) || detailedClaim?.policyName?.toLowerCase().includes('EEI'.toLocaleLowerCase()) || detailedClaim?.policyName?.toLowerCase().includes('GPA'.toLowerCase())
        const isGroupMedical = detailedClaim?.policyType?.toLowerCase().includes('Group Medical'.toLowerCase())

        return (isSTPPolicy && !isSTPZeroOrOne && isEstimatedLossNotMore25000 && isClaimMarine && userRole === 'Insurer') || (isMisc && isMiscPolicy && userRole === 'Insurer') || (isGroupMedical && userRole === 'Insurer') || (userRole === 'Surveyor');
    }

    const isSTPNonZeroOrOne = () => {
        const isSTPPolicy = detailedClaim?.policyName?.toLowerCase().includes('stp');
        const isSTPZeroOrOne = detailedClaim?.policyName?.toLowerCase() === 'stp0' || detailedClaim?.policyName?.toLowerCase() === 'stp 0' || detailedClaim?.policyName?.toLowerCase() === 'stp 1' || detailedClaim?.policyName?.toLowerCase() === 'stp1';
        return isSTPPolicy && !isSTPZeroOrOne;
    }

    const fsrShouldNotBeVisible = () => {
        const isSTPNotZeroOrOne = isSTPNonZeroOrOne();
        const isClaimMarine = detailedClaim?.storageTransitType?.toLowerCase() === 'transit';
        return isSTPNotZeroOrOne && (detailedClaim?.estimatedLoss < 25000 || detailedClaim?.estimatedLoss == 25000) && isClaimMarine;
    }

    return (
        <>
            {activeTab === 'FSR_DOCUMENTS_SELF_SURVEYOR' ?
                userRole === "Surveyor" || detailedClaim?.paymentStatus === "Settled" ? null : <FormGroup className="documents_box_wrap">
                    <Label style={{ fontWeight: "600" }}>Settlement Options:</Label>
                    <div>
                        <Input
                            type="radio"
                            id="fully"
                            name="settlement"
                            value="Fully"
                            checked={settlementType === 'Fully'}
                            onChange={() => {
                                if (detailedClaim?.surveyorAppointmentStatus !== "Self Surveyor" && !detailedClaim?.surveyorAssesmentAmount) {
                                    // if (!detailedClaim?.surveyorAssesmentAmount) {
                                    toast.info(`${getAssesmentLabel()} is Required`)
                                    // }
                                } else {
                                    setSettlementType("Fully")
                                    setShowSettlementModal(true)
                                }
                            }}
                            disabled={detailedClaim?.claimStatus === "Withdrawn" || detailedClaim?.paymentStatus === "Partially Settled"}
                        />
                        <Label for="fully" className="ms-2">Accept and Fully Settle <span style={{ color: "red" }}>{detailedClaim?.paymentStatus === "Partially Settled" ? " ( Not Applicable )" : ""}</span>
                        </Label>
                    </div>
                    <div>
                        <Input
                            type="radio"
                            id="partially"
                            name="settlement"
                            value="Partially"
                            checked={settlementType === 'Partially'}
                            onChange={() => {
                                if (detailedClaim?.surveyorAppointmentStatus !== "Self Surveyor" && !detailedClaim?.surveyorAssesmentAmount) {
                                    // if (!detailedClaim?.surveyorAssesmentAmount) {
                                    toast.info(`${getAssesmentLabel()} is Required`)
                                } else {
                                    setSettlementType("Partially")
                                    setShowSettlementModal(true)
                                }
                            }}
                            disabled={detailedClaim?.claimStatus === "Withdrawn"}
                        />
                        <Label for="partially" className="ms-2">Accept and Partially Settle</Label>
                    </div>
                </FormGroup>
                : activeTab !== 'FSR_DOCUMENTS' ?
                    <div className="tab-content tab_content" id="myTabContent">
                        <div
                            className={`tab-pane fade show active`}
                            id="raise-claimdoc"
                            role="tabpanel"
                            aria-labelledby="raise-claimdoc-tab"
                        >
                            {/* table design start here */}
                            <div className='documents_box_wrap'>
                                {tabLoading ? <Loading height={100} />
                                    : <>
                                        <div className='documents_box_uprwrap'>
                                            <h2 className='documents_box_titleinfo'>{title}</h2>
                                            <div className='documents_box_upr_btn'>
                                                {["LOR_DOCUMENTS"].includes(activeTab) &&
                                                    canAddLor() && <Button color="dark" className="outlineButton button_01"
                                                        onClick={() => handleAddMultipleLOR('ADD')}
                                                        disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                                    ><i className="bx bx-plus" aria-hidden="true"></i>Add LOR
                                                    </Button>
                                                }
                                                {["JIR_DOCUMENTS", "FSR_DOCUMENTS"].includes(activeTab) &&
                                                    <Button color="dark" className="outlineButton button_01"
                                                        onClick={() => handleShow('ADD')}
                                                        disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                                    ><i className="bx bx-plus" aria-hidden="true"></i>{'Add'}
                                                    </Button>
                                                }
                                                {claimDetails?.length > 0 && claimDetails.some(item => item.files.length > 0) && <Button color="dark" className="outlineButton button_01 ms-1" onClick={downloadAll} disabled={(claimDetails?.length < 1 || !claimDetails.some(item => item.files.length > 0)) || false}>
                                                    <i className="fa fa-download" aria-hidden="true" ></i> Download All
                                                </Button>}
                                            </div>
                                        </div>
                                        <div className="table-responsive option_01">
                                            {activeTab === "LOR_DOCUMENTS" ? claimDetails?.length > 0 ? <Table className='tableinr_claimdoc'>
                                                {/* table-bordered */}
                                                <thead>
                                                    <tr>
                                                        <th className='sl-n'>Sl. No.
                                                        </th>
                                                        {activeTab === "LOR_DOCUMENTS" && <th className="tbl-w-3">Required Documents</th>}
                                                        <th className='tbl-w-35'>Documents</th>
                                                        <th className='tbl-w-3'>Documents Description</th>
                                                        <th className='tbl-w-3 text-center'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        claimDetails?.length > 0 && claimDetails?.map((doc, index) => (
                                                            <tr key={doc?.claimId} className={doc.commentStatus == 'Pending' ? 'pending' : ''}>
                                                                <td className='sl-n'>{index + 1}</td>
                                                                <td className="tbl-w-3">{doc?.lorRequiredName || '--'}
                                                                    <span className='m-2'><FaInfoCircle
                                                                        title='Comments by Internal User'
                                                                        onClick={() => {
                                                                            // showCommentHandler(doc.comments, 'Divisional SPOC')
                                                                            showCommentHandler(doc.comments, ['Divisional SPOC', 'Administrator', 'Corporate'], 'Internal User')
                                                                        }}
                                                                        style={{ color: '#6c757d', cursor: 'pointer' }}
                                                                    /></span>
                                                                </td>
                                                                <td className='tbl-w-35'>
                                                                    <div className='d-flex align-items-center'>
                                                                        <div className='mltiple_doc_show'>
                                                                            {
                                                                                doc?.files?.length > 0 ? doc?.files?.map((file, index) => (
                                                                                    <span key={file?.fileId}>{file?.fileName}</span>
                                                                                ))
                                                                                    : '--'
                                                                            }
                                                                        </div>
                                                                        <span className='m-2'><FaInfoCircle
                                                                            title='Comments by External User'
                                                                            onClick={() => {
                                                                                showCommentHandler(doc.comments, ['Insurer', 'Surveyor'], 'External User')
                                                                            }}
                                                                            style={{ color: '#6c757d', cursor: 'pointer' }}
                                                                        /></span>
                                                                    </div>
                                                                </td>
                                                                <td className='tbl-w-3'>{doc?.lorRequiredName ? (doc?.lorDescription || '--') : (doc?.files?.[0]?.fileDescription || '--')}</td>
                                                                <td className='tbl-w-3'>
                                                                    <div className='table_inr_btnwrp'>
                                                                        {['Divisional SPOC', 'Surveyor', 'Administrator'].includes(userRole) &&
                                                                            <Button
                                                                                onClick={() => {
                                                                                    setLorDetails(doc)
                                                                                    handleShow('ADD_COMMENT')
                                                                                }}
                                                                                disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                                                                color="link"
                                                                                className="button_comment claim_actionbtn">
                                                                                <i className="bx bx-comment " aria-hidden="true" style={{ fontSize: '18px' }}></i>
                                                                                Comment
                                                                            </Button>}

                                                                        {doc?.files?.length > 0 && <Button
                                                                            onClick={() => downloadDoc(doc)}
                                                                            color="link"
                                                                            className=" button_download claim_actionbtn">
                                                                            <i className="bx bx-import " aria-hidden="true" style={{ fontSize: '20px' }}></i>
                                                                            Download
                                                                        </Button>}

                                                                        {doc?.lorRequiredName && canAddLor() && <Button
                                                                            className='button_cross claim_actionbtn'
                                                                            color="link"
                                                                            style={{ color: 'red' }}
                                                                            onClick={() => {
                                                                                setShowDeleteReqNameModal(true)
                                                                                setRequiredNameDeleteDetails({ type: 'lor_required', id: doc?.lorRequiredId })
                                                                            }}
                                                                            disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                                                        >
                                                                            <i className="bx bx-x" style={{ fontSize: '20px' }}></i>
                                                                        </Button>}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </Table> : <p className='text-center'>No Data Found</p> : null}
                                            {activeTab !== "LOR_DOCUMENTS" ? claimDetails?.length > 0 && claimDetails?.[0]?.files?.length > 0 ? <Table className='tableinr_claimdoc'>
                                                {/* table-bordered */}
                                                <thead>
                                                    <tr>
                                                        <th className='sl-n'>Sl. No.
                                                        </th>
                                                        <th className='tbl-w-35'>Documents</th>
                                                        <th className='tbl-w-3'>Documents Description</th>
                                                        <th className='tbl-w-3 text-center'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        claimDetails?.length > 0 && claimDetails[0]?.files.map((doc, index) => (
                                                            <tr key={doc?.claimId}>
                                                                <td className='sl-n'>{index + 1}</td>
                                                                <td className='tbl-w-35 mltiple_doc_show'>
                                                                    <span key={doc?.fileId}>{doc?.fileName || '--'}</span>
                                                                </td>
                                                                <td className='tbl-w-3'>{doc?.fileDescription || '--'}</td>
                                                                <td className='tbl-w-3'>
                                                                    <div className='table_inr_btnwrp'>
                                                                        {activeTab !== 'CLAIM_DOC_LIST_DURING_RAISE' && <Button
                                                                            className=" button_trash claim_actionbtn"
                                                                            onClick={() => {
                                                                                setDeleteId(doc?.fileId)
                                                                                handleShow('DELETE')
                                                                            }}
                                                                            disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                                                            color="link"
                                                                        >
                                                                            <i className="bx bx-trash" style={{ fontSize: '20px' }}></i>
                                                                            Delete
                                                                        </Button>}
                                                                        <Button
                                                                            onClick={() => downloadDoc(doc)}
                                                                            color="link"
                                                                            className=" button_download claim_actionbtn">
                                                                            <i className="bx bx-import " aria-hidden="true" style={{ fontSize: '20px' }}></i>
                                                                            Download
                                                                        </Button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </Table> : <p className='text-center'>No Data Found</p> : null}
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div> :
                    tabLoading ? <Loading height={100} /> : <>
                        <UncontrolledAccordion defaultOpen={['FSR_DOCUMENTS']} stayOpen className="tab-content tab_content" id="myTabContent">
                            {fsrShouldNotBeVisible() ? null : <AccordionItem
                                className="tab-pane fade show active itc_accordian"
                                id="raise-claimdoc"
                                role="tabpanel"
                                aria-labelledby="raise-claimdoc-tab"
                            >
                                {/* table design start here */}
                                <div className='documents_box_wrap'>
                                    <AccordionHeader targetId="FSR_DOCUMENTS">
                                        <h2 className='documents_box_titleinfo'>{title}</h2>
                                    </AccordionHeader>
                                    <AccordionBody className="table-responsive option_01" accordionId="FSR_DOCUMENTS">
                                        <div className='documents_box_upr_btn'>
                                            {
                                                <Button color="dark" className="outlineButton button_01 mb-2 me-2"
                                                    onClick={() => {
                                                        setFileType('fsr')
                                                        handleShow('ADD')
                                                    }}
                                                    disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                                ><i className="bx bx-plus" aria-hidden="true"></i>{'Add'}
                                                </Button>
                                            }
                                            {claimDetails?.length > 0 && claimDetails.some(item => item.files.length > 0) && <Button color="dark" className="outlineButton button_01 mb-2" onClick={() => {
                                                downloadAll('fsr');
                                            }}
                                                disabled={(claimDetails?.length < 1 || !claimDetails.some(item => item.files.length > 0)) || false}>
                                                <i className="fa fa-download" aria-hidden="true" ></i> Download All
                                            </Button>}
                                        </div>
                                        {claimDetails?.length > 0 && claimDetails?.[0]?.files?.length > 0 ? <Table className='tableinr_claimdoc'>
                                            {/* table-bordered */}
                                            <thead>
                                                <tr>
                                                    <th className='sl-n'>Sl. No.</th>
                                                    <th className='tbl-w-35'>Documents</th>
                                                    <th className='tbl-w-3'>Documents Description</th>
                                                    <th className='tbl-w-3 text-center'>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    claimDetails?.length > 0 && claimDetails[0]?.files.map((doc, index) => (
                                                        <tr key={doc?.claimId}>
                                                            <td className='sl-n'>{index + 1}</td>
                                                            <td className='tbl-w-35 mltiple_doc_show'>
                                                                <span key={doc?.fileId}>{doc?.fileName || '--'}</span>
                                                            </td>
                                                            <td className='tbl-w-3'>{doc?.fileDescription || '--'}</td>
                                                            <td className='tbl-w-3'>
                                                                <div className='table_inr_btnwrp'>

                                                                    {<Button
                                                                        className=" button_trash claim_actionbtn"
                                                                        onClick={() => {
                                                                            setDeleteId(doc?.fileId)
                                                                            setFileType('fsr')
                                                                            handleShow('DELETE')
                                                                        }}
                                                                        disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                                                        color="link"
                                                                    >
                                                                        <i className="bx bx-trash" style={{ fontSize: '20px' }}></i>
                                                                        Delete
                                                                    </Button>}
                                                                    <Button
                                                                        onClick={() => {
                                                                            downloadDoc(doc, 'fsr')
                                                                        }}
                                                                        color="link"
                                                                        className=" button_download claim_actionbtn">
                                                                        <i className="bx bx-import " aria-hidden="true" style={{ fontSize: '20px' }}></i>
                                                                        Download
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table> : <p className='text-center'>No Data Found</p>}
                                    </AccordionBody>
                                </div>
                            </AccordionItem>}
                            <AccordionItem
                                className="tab-pane fade show active itc_accordian"
                                id="raise-claimdoc"
                                role="tabpanel"
                                aria-labelledby="raise-claimdoc-tab"
                            >
                                {/* table design start here */}
                                <div className='documents_box_wrap'>
                                    <AccordionHeader targetId="OTHER_DOCUMENTS">
                                        <h2 className='documents_box_titleinfo'>Other Documents</h2>
                                    </AccordionHeader>
                                    <AccordionBody className="table-responsive option_01" accordionId="OTHER_DOCUMENTS">
                                        <div className='documents_box_upr_btn mb-2'>
                                            {(userRole === 'Surveyor' || userRole === 'Divisional SPOC') && <Button color="dark" className="outlineButton button_01 ms-1"
                                                onClick={() => {
                                                    setFileType('other_document')
                                                    handleShow('ADD')
                                                }}
                                                disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                            ><i className="bx bx-plus" aria-hidden="true"></i>Add More
                                            </Button>}
                                            {userRole === 'Insurer' && <Button color="dark" className="outlineButton button_01 ms-1" onClick={() => setShowAddOtherModal(true)}
                                                disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                            ><i className="bx bx-plus" aria-hidden="true"></i>Add
                                            </Button>}
                                            {otherDocument?.length > 0 && otherDocument.some(item => item.files.length > 0) && <Button color="dark" className="outlineButton button_01 ms-1" onClick={() => {
                                                downloadAll('other_document')
                                            }} disabled={(otherDocument?.length < 1 || !otherDocument.some(item => item.files.length > 0)) || false}>
                                                <i className="fa fa-download" aria-hidden="true" ></i> Download All
                                            </Button>}
                                        </div>
                                        {otherDocument?.length > 0 ? <Table className='tableinr_claimdoc'>
                                            {/* table-bordered */}
                                            <thead>
                                                <tr>
                                                    <th className='sl-n'>Sl. No.
                                                    </th>
                                                    <th className="tbl-w-3">Required Documents</th>
                                                    <th className='tbl-w-35'>Documents</th>
                                                    <th className='tbl-w-3'>Documents Description</th>
                                                    <th className='tbl-w-3'>Tagged Role</th>
                                                    <th className='tbl-w-3 text-center'>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    otherDocument?.length > 0 && otherDocument.map((doc, index) => (
                                                        <tr key={doc?.claimId} className={doc.commentStatus == 'Pending' ? 'pending' : ''}>
                                                            <td className='sl-n'>{index + 1}</td>
                                                            <td className="tbl-w-3">{doc?.lorRequiredName ? doc.lorRequiredName : '--'}
                                                                {doc?.lorRequiredName && <span className='m-2'><FaInfoCircle
                                                                    title={`Comments by ${doc?.taggedRole}`}
                                                                    onClick={() => {
                                                                        showCommentHandler(doc.comments, doc?.taggedRole)
                                                                    }}
                                                                    style={{ color: '#6c757d', cursor: 'pointer' }}
                                                                /></span>}
                                                            </td>
                                                            <td className='tbl-w-35'>
                                                                <div className='d-flex align-items-center'>
                                                                    <div className='mltiple_doc_show'>
                                                                        {
                                                                            doc?.files?.length > 0 ? doc?.files?.map((file, index) => (
                                                                                <span key={file?.fileId}>{file?.fileName}</span>
                                                                            ))
                                                                                : '--'
                                                                        }
                                                                    </div>
                                                                    {doc?.lorRequiredName && <span className='m-2'>
                                                                        <FaInfoCircle
                                                                            title='Comments by Insurer'
                                                                            onClick={() => {
                                                                                showCommentHandler(doc.comments, 'Insurer')
                                                                            }}
                                                                            style={{ color: '#6c757d', cursor: 'pointer' }}
                                                                        /></span>}
                                                                </div>
                                                            </td>
                                                            <td className='tbl-w-3'>{doc?.lorRequiredName ? (doc?.lorDescription || '--') : (doc?.files?.[0]?.fileDescription || '--')}</td>
                                                            <td className='tbl-w-3'>{doc?.taggedRole || '--'}</td>
                                                            <td className='tbl-w-3'>
                                                                <div className='table_inr_btnwrp'>
                                                                    {['Divisional SPOC', 'Surveyor', 'Insurer', 'Administrator'].includes(userRole) && doc?.lorRequiredName && (userRole === doc?.taggedRole || userRole === 'Insurer') && <Button
                                                                        onClick={() => {
                                                                            setLorDetails(doc)
                                                                            setOtherDocTaggedRole(doc?.taggedRole)
                                                                            handleShow('ADD_COMMENT')
                                                                        }}
                                                                        disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                                                        color="link"
                                                                        className="button_comment claim_actionbtn">
                                                                        <i className="bx bx-comment" aria-hidden="true" style={{ fontSize: '18px' }}></i>
                                                                        Comment
                                                                    </Button>}
                                                                    {doc?.lorRequiredName && userRole === doc?.taggedRole && <Button
                                                                        className='p-0'
                                                                        color="link"
                                                                        onClick={() => {
                                                                            setFileType('other_document')
                                                                            handleAddMultipleLORFiles({
                                                                                lorRequiredId: doc?.lorRequiredId,
                                                                                lorDescription: doc?.lorDescription
                                                                            })
                                                                        }}
                                                                        disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                                                    >
                                                                        <i className="bx bx-plus" style={{ fontSize: '20px' }}></i>
                                                                    </Button>}
                                                                    {doc?.files?.length > 0 && userRole === doc?.taggedRole && <Button
                                                                        className=" button_trash claim_actionbtn"
                                                                        onClick={() => {
                                                                            setDeleteFiles(doc?.files)
                                                                            setShowMultipleFileDeleteModal(true)
                                                                            setFileType('other_document')
                                                                        }}
                                                                        disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                                                        color="link"
                                                                    >
                                                                        <i className="bx bx-trash" style={{ fontSize: '20px' }}></i>
                                                                        Delete
                                                                    </Button>}
                                                                    {doc?.files?.length > 0 && <Button
                                                                        onClick={() => {
                                                                            downloadDoc(doc, 'other_document')
                                                                        }}
                                                                        color="link"
                                                                        className=" button_download claim_actionbtn">
                                                                        <i className="bx bx-import " aria-hidden="true" style={{ fontSize: '20px' }}></i>
                                                                        Download
                                                                    </Button>}
                                                                    {doc?.lorRequiredName && userRole === 'Insurer' && <Button
                                                                        className='button_cross claim_actionbtn'
                                                                        color="link"
                                                                        style={{ color: 'red' }}
                                                                        onClick={() => {
                                                                            setShowDeleteReqNameModal(true)
                                                                            setRequiredNameDeleteDetails({ type: 'other_document_required', id: doc?.lorRequiredId })
                                                                        }}
                                                                        disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                                                    >
                                                                        <i className="bx bx-x" style={{ fontSize: '20px' }}></i>
                                                                    </Button>}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table> : <p className='text-center'>No Data Found</p>}
                                    </AccordionBody>
                                </div>
                            </AccordionItem>
                            <AccordionItem
                                className="tab-pane fade show active itc_accordian"
                                id="raise-claimdoc"
                                role="tabpanel"
                                aria-labelledby="raise-claimdoc-tab"
                            >
                                {/* table design start here */}
                                <div className='documents_box_wrap'>
                                    {tabLoading ? <Loading height={100} />
                                        : <>
                                            <AccordionHeader targetId="PR_DC_DOCUMENTS">
                                                <h2 className='documents_box_titleinfo'>Final Police Report & Destruction Certificate</h2>
                                                {/* <div className='documents_box_upr_btn'>
                                            {PrDcDocument?.length > 0 && PrDcDocument.some(item => item.files.length > 0) && <Button color="dark" className="outlineButton button_01 ms-1" onClick={() => {
                                                downloadAll('final_police_report)
                                            }} disabled={(PrDcDocument?.length < 1 || !PrDcDocument.some(item => item.files.length > 0)) || false}>
                                                <i className="fa fa-download" aria-hidden="true" ></i> Download All
                                            </Button>}
                                        </div> */}
                                            </AccordionHeader>
                                            <AccordionBody className="table-responsive option_01" accordionId="PR_DC_DOCUMENTS">
                                                {PrDcDocument?.length > 0 ? <Table className='tableinr_claimdoc'>
                                                    {/* table-bordered */}
                                                    <thead>
                                                        <tr>
                                                            <th className='sl-n'>Sl. No.
                                                            </th>
                                                            <th className="tbl-w-3">Required Documents</th>
                                                            <th className='tbl-w-35'>Documents</th>
                                                            <th className='tbl-w-3'>Documents Description</th>
                                                            <th className='tbl-w-3 text-center'>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            PrDcDocument?.length > 0 && PrDcDocument.map((doc, index) => (
                                                                <tr key={doc?.claimId}>
                                                                    <td className='sl-n'>{index + 1}</td>
                                                                    <td className="tbl-w-3">{doc?.lorRequiredName === 'destruction_certificate' ? 'Destruction Certificate' : 'Final Police Report' || '--'}</td>
                                                                    <td className='tbl-w-35'>
                                                                        <div className='d-flex align-items-center'>
                                                                            <div className='mltiple_doc_show'>
                                                                                {
                                                                                    doc?.files?.length > 0 ? doc?.files?.map((file, index) => (
                                                                                        <span key={file?.fileId}>{file?.fileName}</span>

                                                                                    ))
                                                                                        : '--'
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td className='tbl-w-3'>{doc?.files?.length > 0 && doc?.files[0]?.fileDescription || '--'}</td>
                                                                    <td className='tbl-w-3'>
                                                                        <div className='table_inr_btnwrp'>
                                                                            {doc?.files?.length < 1 && ((userRole === 'Surveyor' && doc?.lorRequiredName === 'destruction_certificate') || (userRole === 'Divisional SPOC' && doc?.lorRequiredName === 'final_police_report')) && <Button
                                                                                className='p-0'
                                                                                color="link"
                                                                                onClick={() => {
                                                                                    setFileType(doc?.lorRequiredName);
                                                                                    handleAddMultipleLORFiles({
                                                                                        lorRequiredId: doc?.lorRequiredId,
                                                                                        lorDescription: doc?.lorDescription
                                                                                    })
                                                                                }}
                                                                                disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                                                            >
                                                                                <i className="bx bx-plus" style={{ fontSize: '20px' }}></i>
                                                                            </Button>}
                                                                            {doc?.files?.length > 0 && ((userRole === 'Surveyor' && doc?.lorRequiredName === 'destruction_certificate') || (userRole === 'Divisional SPOC' && doc?.lorRequiredName === 'final_police_report')) && <Button
                                                                                className=" button_trash claim_actionbtn"
                                                                                onClick={() => {
                                                                                    setDeleteFiles(doc?.files)
                                                                                    setShowMultipleFileDeleteModal(true)
                                                                                    setFileType(doc?.lorRequiredName)
                                                                                }}
                                                                                disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                                                                color="link"
                                                                            >
                                                                                <i className="bx bx-trash" style={{ fontSize: '20px' }}></i>
                                                                                Delete
                                                                            </Button>}
                                                                            {doc?.files?.length > 0 && <Button
                                                                                onClick={() => {
                                                                                    downloadDoc(doc, doc?.lorRequiredName)
                                                                                }}
                                                                                color="link"
                                                                                className=" button_download claim_actionbtn">
                                                                                <i className="bx bx-import " aria-hidden="true" style={{ fontSize: '20px' }}></i>
                                                                                Download
                                                                            </Button>}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </Table> : <p className='text-center'>No Data Found</p>}
                                            </AccordionBody>
                                        </>
                                    }
                                </div>
                            </AccordionItem>
                        </UncontrolledAccordion>
                        {userRole === "Surveyor" || detailedClaim?.paymentStatus === "Settled" ? null :
                            <FormGroup className="documents_box_wrap">
                                <Label style={{ fontWeight: "600" }}>Settlement Options:</Label>
                                <div>
                                    <Input
                                        type="radio"
                                        id="fully"
                                        name="settlement"
                                        value="Fully"
                                        checked={settlementType === 'Fully'}
                                        onChange={() => {
                                            if (detailedClaim?.surveyorAppointmentStatus !== "Self Surveyor" && !detailedClaim?.surveyorAssesmentAmount) {
                                                // if (!detailedClaim?.surveyorAssesmentAmount) {
                                                toast.info(`${getAssesmentLabel()} is Required`)
                                                // }
                                            } else {
                                                setSettlementType("Fully")
                                                setShowSettlementModal(true)
                                            }
                                        }}
                                        disabled={detailedClaim?.claimStatus === "Withdrawn" || detailedClaim?.paymentStatus === "Partially Settled"}
                                    />
                                    <Label for="fully" className="ms-2">Accept and Fully Settle<span style={{ color: "red" }}>{detailedClaim?.paymentStatus === "Partially Settled" ? " ( Not Applicable )" : ""}</span></Label>
                                </div>
                                <div>
                                    <Input
                                        type="radio"
                                        id="partially"
                                        name="settlement"
                                        value="Partially"
                                        checked={settlementType === 'Partially'}
                                        onChange={() => {
                                            if (detailedClaim?.surveyorAppointmentStatus !== "Self Surveyor" && !detailedClaim?.surveyorAssesmentAmount) {
                                                // if (!detailedClaim?.surveyorAssesmentAmount) {
                                                toast.info(`${getAssesmentLabel()} is Required`)
                                            } else {
                                                setSettlementType("Partially")
                                                setShowSettlementModal(true)
                                            }
                                        }}
                                        disabled={detailedClaim?.claimStatus === "Withdrawn"}
                                    />
                                    <Label for="partially" className="ms-2">Accept and Partially Settle</Label>
                                </div>
                            </FormGroup>}
                    </>}

            {/* this is adding for testing purpose */}
            <ClaimDocumentUploadCommonModal
                openModal={(showAddModal && lorCount !== 0 && activeTab === "JIR_DOCUMENTS") || (showAddModal && activeTab !== "JIR_DOCUMENTS")}
                activeTab={activeTab}
                setOpenModal={setShowAddModal}
                handleClose={handleClose}
                upload={AddDoc}
                importLabel={activeTab === 'FSR_DOCUMENTS' ? fileType === 'fsr' ? 'FSR Document' : 'Other Document' : modalTitleHandler(activeTab)}
                lorCount={lorCount}
                isLoading={isLoading}
            />

            <JirLorUploadCommonModal
                openModal={showAddModal && lorCount === 0 && activeTab === "JIR_DOCUMENTS"}
                activeTab={activeTab}
                setOpenModal={setShowAddModal}
                handleClose={handleClose}
                upload={AddLORAndJIRFiles}
                importLabel={modalTitleHandler(activeTab)}
                lorCount={lorCount}
                isLoading={isLoading}
            />

            <MultipleLORFilesUploadModal
                isModalOpen={showAddLorFilesModal}
                handleClose={() => setShowAddLorFilesModal(false)}
                upload={AddLORFiles}
                lorDetails={lorDetails}
                isLoading={isLoading}
                title={activeTab === 'LOR_DOCUMENTS' ? 'LOR Document Upload' : fileType == 'other_document' ? 'Other Document Upload' : fileType == 'destruction_certificate' ? 'Destruction Certificate Upload' : fileType == 'final_police_report' ? 'Final Police Report Upload' : ''}
                fileType={fileType}
            />

            <MultipleLorAddCommonModal
                isModalOpen={showAddLorModal}
                openModal={() => setShowAddLorModal(true)}
                handleClose={() => setShowAddLorModal(false)}
                acceptedExt={'docx'}
                importLabel={"LOR List Upload"}
                upload={AddLOR}
                isLoading={isLoading}
            />

            <CommonDocumentCommentModal
                isOpen={addCommentModal}
                closeModal={() => setAddCommentModal(false)}
                action={activeTab}
                isLoading={isLoading}
                submitHandler={addComment}
            />

            <CommonCommentModal
                openModal={showCommentModal}
                handleClose={() => handleClose('SHOW_COMMENT')}
                user={userRole}
                commentList={commentsList}
                commentedUserType={commentedUserType}
            />
            <MultipleAmountAddCommonModal
                isModalOpen={showSettlementModal}
                handleClose={() => {
                    setShowSettlementModal(false)
                    setSettlementType('');
                }}
                claimDetails={detailedClaim}
                fetchClaimTemplateDetails={fetchClaimTemplateDetails}
                raiseClaimId={claimId}
                checkSettled={settlementType}
            />
            <Modal isOpen={showMultipleFileDeleteModal} toggle={() => setShowMultipleFileDeleteModal(false)}>
                <ModalHeader toggle={() => setShowMultipleFileDeleteModal(false)}>Delete Documents</ModalHeader>
                <ModalBody>
                    <div className='deletedoc_modal_bodypart'>
                        <div className='deletedoc_modal_inrpart'>
                            {deleteFiles?.length > 0 && deleteFiles.map((file) => {
                                return <h6 className='modal_inrpartshow_doc' key={file.fileId}>{file?.fileName}<span><i className="bx bx-x" onClick={() => {
                                    setDeleteId(file.fileId);
                                    handleShow('DELETE');
                                }}></i></span></h6>
                            })}
                        </div>
                    </div>
                </ModalBody>
            </Modal >

            <Modal isOpen={showDeleteModal} toggle={() => handleClose('DELETE')}>
                <ModalHeader toggle={() => handleClose('DELETE')}>Delete Document</ModalHeader>
                <ModalBody>
                    Are you sure you want to delete this document?
                    <ModalFooter className="border-0">
                        <Button color="primary" className="ITC_Blue_color" type="submit" onClick={handleDelete} disabled={isLoading}>
                            Yes
                        </Button>
                    </ModalFooter>
                </ModalBody>
            </Modal>

            <Modal isOpen={showDeleteReqNameModal} toggle={() => setShowDeleteReqNameModal(false)}>
                <ModalHeader toggle={() => setShowDeleteReqNameModal(false)}>Delete Required Name</ModalHeader>
                <ModalBody>
                    Are you sure you want to delete this required name?
                    <ModalFooter className="border-0">
                        <Button color="primary" className="ITC_Blue_color" type="submit" onClick={handleDeleteRequiredName} disabled={isLoading}>
                            Yes
                        </Button>
                    </ModalFooter>
                </ModalBody>
            </Modal>

            <MultipleOtherDocModal
                isModalOpen={showAddOtherModal}
                openModal={() => setShowAddOtherModal(true)}
                handleClose={() => setShowAddOtherModal(false)}
                acceptedExt={'docx'}
                importLabel={"Other Document Requirement List Upload"}
                upload={AddOtherDocReq}
                isLoading={isLoading}
            />

        </>
    )
}

export default ClaimDocumentTabCmp